// const roundDown = (arg1: number) => Math.floor(arg1 * 100) / 100;
/**
 * Adjusts a number to the specified digit.
 *
 * @param {"round" | "floor" | "ceil"} type The type of adjustment.
 * @param {number} value The number.
 * @param {number} exp The exponent (the 10 logarithm of the adjustment base).
 * @returns {number} The adjusted value.
 */
function decimalAdjust(type, value, exp) {
  type = String(type);
  if (!['round', 'floor', 'ceil'].includes(type)) {
    throw new TypeError(
      "The type of decimal adjustment must be one of 'round', 'floor', or 'ceil'."
    );
  }
  exp = Number(exp);
  value = Number(value);
  if (exp % 1 !== 0 || Number.isNaN(value)) {
    return NaN;
  } else if (exp === 0) {
    return Math[type](value);
  }
  const [magnitude, exponent = 0] = value.toString().split('e');
  const adjustedValue = Math[type](`${magnitude}e${exponent - exp}`);
  // Shift back
  const [newMagnitude, newExponent = 0] = adjustedValue.toString().split('e');
  return Number(`${newMagnitude}e${+newExponent + exp}`);
}

// Decimal round
const roundDown = (value, exp = -2) => decimalAdjust('floor', value, exp * -1);

// Decimal round up
const roundUp = (value, exp = -2) => decimalAdjust('round', value, exp * -1);

// Decimal round to nearest
const round = (value, exp = -2) => decimalAdjust('round', value, exp);

const functionLibrary = {
  roundDown,
  roundUp,
  round,
};

export default functionLibrary;
